module.exports = __webpack_public_path__ + "static/media/ShgnFooterMark.c7ed952e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/ShgnFooterMark.svg
// module id = 176
// module chunks = 0